import React, { useRef } from 'react';
import { UploadIcon } from 'lucide-react';
import { BUTTON_QUIET } from './adminStyles';
interface TranscriptUploadProps {
  /** Current transcript text, if one has been uploaded. */
  value: string;
  onChange: (text: string) => void;
}

/**
 * Transcripts are written elsewhere (usually Descript) and uploaded here as a
 * text file. Nothing is generated or transformed — Portal just holds the text.
 */
export function TranscriptUpload({
  value,
  onChange
}: TranscriptUploadProps) {
  const fileRef = useRef<HTMLInputElement>(null);
  const words = value.trim() ? value.trim().split(/\s+/).length : 0;
  function read(file: File | undefined) {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => onChange(String(reader.result ?? ''));
    reader.readAsText(file);
  }
  return <div className="mt-8" data-id="element-381" data-mp="1g3c0nrm5naeo">
      <span className="label block text-paper/40" data-id="element-382" data-mp="1g3vn9lmr2mz1">Transcript File</span>
      <div className="mt-4 flex flex-wrap items-center gap-6 border-b border-paper/25 pb-4" data-id="element-383" data-mp="1b6ve31ult43p">
        <button type="button" onClick={() => fileRef.current?.click()} className={BUTTON_QUIET} data-id="element-384" data-mp="3jp4n1g3y6qyz">
          <span className="flex items-center gap-3" data-id="element-385" data-mp="3ohxre2vi7xaj">
            <UploadIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-386" data-mp="3aphmewj1lp6z" />
            {words > 0 ? 'Replace File' : 'Upload File'}
          </span>
        </button>
        <p className="label-sm m-0 text-paper/30" data-id="element-387" data-mp="3fpdo2p49p4jd">
          {words > 0 ? `${words.toLocaleString()} words uploaded` : '.txt or .vtt from Descript'}
        </p>
      </div>
      <input ref={fileRef} type="file" accept=".txt,.vtt,.srt,text/plain" onChange={event => {
      read(event.target.files?.[0]);
      event.target.value = '';
    }} className="hidden" data-id="element-388" data-mp="banol03pzv54" />
    </div>;
}